import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import TableAHSF from "../../../../Components/TableAHSF";
import Swal from "sweetalert2";
import { decryptToken } from "../../../../Services/Encryption/EncryptionParams";
import AllDropDownsAHSF from "../../../../Components/AllDropDownsAHSF";
import InputAHSF from "../../../../Components/InputAHSF";
import TextAreaAHSF from "../../../../Components/TextAreaAHSF";
import { GetItemType } from "../../../../Redux/Reducers/Submitter/WPBItemType";
import { AddBudgetItemsRequestedFromSoman, EditBudgetItemsRequestedFromSoman, GetBudgetItemsRequestedFromSomanById } from "../../../../Redux/Reducers/Submitter/BudgetItemsRequestedFromSoman";
import ButtonAHSF from "../../../../Components/ButtonAHSF";
import $ from "jquery";
import { GetObjectivesAndActivitiesDropDown } from "../../../../Redux/Reducers/Submitter/ObjectivesAndActivities";

const BudgetItemsRequestedFromSomanAdd = (props) => {
    const dispatch = useDispatch()
    const BudgetItemsRequestedFromSoman = useSelector((state) => state.BudgetItemsRequestedFromSomanReducers.GetBudgetItemsRequestedFromSomanById)
    const ObjectivesAndActivities = useSelector((state) => state.ObjectivesAndActivitiesReducers.ObjectivesAndActivitiesDropDown)
    const ItemTypeList = useSelector((state) => state.ItemTypeReducers.ItemType)
    const [ItemTypeId, setItemTypeId] = useState(null)
    const [ItemName, setItemName] = useState(null)
    const [ItemDesecrabtion, setItemDesecrabtion] = useState(null)
    const [NumberOfunit, setNumberOfunit] = useState(null)
    const [UnitPrice, setUnitPrice] = useState(null)
    const [ObjectivesAndActivitiesId, setObjectivesAndActivitiesId] = useState(null)
    const [Total, setTotal] = useState(null)

    console.log(ObjectivesAndActivities, "sdsdsdsdsdsd");

    const [ItemTypeIdValidation, setItemTypeIdValidation] = useState(null)
    const [ItemNameValidation, setItemNameValidation] = useState(false)
    const [ItemDesecrabtionValidation, setItemDesecrabtionValidation] = useState(false)
    const [NumberOfunitValidation, setNumberOfunitValidation] = useState(false)
    const [UnitPriceValidation, setUnitPriceValidation] = useState(false)
    const [ObjectivesAndActivitiesIdValidation, setObjectivesAndActivitiesIdValidation] = useState(null)


    const validation = () => {
        let validation = true;
        if (ItemTypeId == null || ItemTypeId == "") {
            setItemTypeIdValidation(true)
            validation = false
        } else {
            setItemTypeIdValidation(false)

        }
        if (ItemName == null || ItemName == "") {
            setItemNameValidation(true)
            validation = false
        } else {
            setItemNameValidation(false)

        }
        if (ItemDesecrabtion == null || ItemDesecrabtion == "") {
            setItemDesecrabtionValidation(true)
            validation = false

        } else {
            setItemDesecrabtionValidation(false)

        }
        if (NumberOfunit == null || NumberOfunit == "") {
            setNumberOfunitValidation(true)
            validation = false

        } else {
            setNumberOfunitValidation(false)

        }
        if (UnitPrice == null || UnitPrice == "") {
            setUnitPriceValidation(true)
            validation = false

        } else {
            setUnitPriceValidation(false)

        }
        if (ObjectivesAndActivitiesId == null || ObjectivesAndActivitiesId == "") {
            setObjectivesAndActivitiesIdValidation(true)
            validation = false

        } else {
            setObjectivesAndActivitiesIdValidation(false)

        }
        return validation
    }



    useEffect(() => {
        dispatch(GetItemType())
        dispatch(GetObjectivesAndActivitiesDropDown({ ApplicationInformationId: localStorage.getItem("ApplicationInformationId") }))
    }, [])



    useEffect(() => {
        console.log(props.BudgetItemsRequestedFromSomanId, "kjskjdsdsd");

        if (props.Action == "edit") {
            dispatch(GetBudgetItemsRequestedFromSomanById({ BudgetItemsRequestedFromSomanId: props.BudgetItemsRequestedFromSomanId }))

        }
    }, [props.BudgetItemsRequestedFromSomanId])

    // console.log(BudgetItemsRequestedFromSoman, "sdasdasdsad");

    useEffect(() => {
        if (props.ViewData) {
            setItemTypeId(BudgetItemsRequestedFromSoman?.itemTypeId)
            setItemName(BudgetItemsRequestedFromSoman?.itemName);
            setItemDesecrabtion(BudgetItemsRequestedFromSoman?.itemDescription)
            setNumberOfunit(BudgetItemsRequestedFromSoman?.numberOfUnits)
            setUnitPrice(BudgetItemsRequestedFromSoman?.unitPrice)
            setObjectivesAndActivitiesId(BudgetItemsRequestedFromSoman?.objectivesAndActivitiesId)
        }
    }, [BudgetItemsRequestedFromSoman])

    const AddItemsRequestedFromSomanAdd = () => {
        if (validation()) {


            dispatch(AddBudgetItemsRequestedFromSoman({
                itemTypeId: parseInt(ItemTypeId),
                itemName: ItemName,
                itemDescription: ItemDesecrabtion,
                numberOfUnits: parseFloat(NumberOfunit),
                objectivesAndActivitiesId: ObjectivesAndActivitiesId,
                unitPrice: parseFloat(UnitPrice),
                total: UnitPrice * NumberOfunit,
                applicationInformationId: localStorage.getItem("ApplicationInformationId")
            }))
            Swal.fire({
                position: "center",
                icon: "success",
                title: "تمت الأضافة بنجاح",
                showConfirmButton: false,
                timer: 1500,
                // width: "500px",
              });
            $(".close-btn").trigger("click");
        }

    }

    const EditItemsRequestedFromSomanAdd = () => {
        if (validation()) {
            dispatch(EditBudgetItemsRequestedFromSoman({
                budgetItemsRequestedFromSomanId: BudgetItemsRequestedFromSoman?.budgetItemsRequestedFromSomanId,
                itemTypeId: parseInt(ItemTypeId),
                itemName: ItemName,
                itemDescription: ItemDesecrabtion,
                objectivesAndActivitiesId: ObjectivesAndActivitiesId,
                numberOfUnits: parseFloat(NumberOfunit),
                unitPrice: parseFloat(UnitPrice),
                total: UnitPrice * NumberOfunit,
                applicationInformationId: localStorage.getItem("ApplicationInformationId")
            }))
            Swal.fire({
                position: "center",
                icon: "success",
                title: "تم التعديل بنجاح",
                showConfirmButton: false,
                timer: 1500,
                // width: "500px",
              });
            $(".close-btn").trigger("click");
        }

    }


    const HTML = <>
        <div className="ContainerContributionOfSecondTeam">
            <div className="SectionOne">
                <AllDropDownsAHSF
                    fieldsName="ItemType"
                    show={true}
                    disabled={props.shouldDisableFields}
                    dropdownType="normal"
                    arrayOoptionList={ItemTypeList}
                    KeyText={"itemName"}
                    KeyValue={"itemTypeId"}
                    defaultValue={props.ViewData ? BudgetItemsRequestedFromSoman?.itemTypeId
                        : ""}
                    onChange={(e) => {

                        setItemTypeId(e.target.value)
                    }}
                    showValidationMessage={
                        ItemTypeIdValidation
                    }
                    validationMessage="يرجى تعبئة هذا الحقل"
                />
                <InputAHSF
                    fieldsName="ItemName"
                    show={true}
                    disabled={props.shouldDisableFields}

                    onChange={(e) => {
                        setItemName(e.target.value);
                    }}
                    showValidationMessage={ItemNameValidation}
                    defaultValue={props.ViewData ? BudgetItemsRequestedFromSoman?.
                        itemName
                        : ""}
                    validationMessage={"حقل اجباري"}
                />
                 <AllDropDownsAHSF
                    fieldsName="ActivityRelatedToThisItem"
                    show={true}
                    disabled={props.shouldDisableFields}

                    dropdownType="normal"
                    arrayOoptionList={ObjectivesAndActivities}
                    KeyText={"activities"}
                    KeyValue={"objectivesAndActivitiesId"}
                    defaultValue={props.ViewData ? BudgetItemsRequestedFromSoman?.objectivesAndActivitiesId
                        : ""}
                    onChange={(e) => {
                        console.log(e, "dsfsdfsdfsdfeeeee");

                        setObjectivesAndActivitiesId(e.target.value)
                    }}
                    showValidationMessage={
                        ObjectivesAndActivitiesIdValidation
                    }
                    validationMessage="يرجى تعبئة هذا الحقل"
                />
               
            </div>
            <div className="Sectiontow">
            <TextAreaAHSF
                    fieldsName="ItemDescription"
                    show={true}
                    disabled={props.shouldDisableFields}


                    onChange={(e) => {
                        setItemDesecrabtion(e.target.value);
                    }}
                    defaultValue={props.ViewData ? BudgetItemsRequestedFromSoman?.
                        itemDescription
                        : ""}
                    showValidationMessage={
                        ItemDesecrabtionValidation
                    }
                    validationMessage="يرجى تعبئة هذا الحقل"
                />
                </div>
            <div className="Sectiontow">
               
                <InputAHSF
                    fieldsName="NumberOfUnits"
                    show={true}
                    comma={true}
                    disabled={props.shouldDisableFields}

                    defaultValue={props.ViewData ? BudgetItemsRequestedFromSoman?.
                        numberOfUnits
                        : ""}
                    onChange={(e) => {
                        setNumberOfunit(e.target.value);
                    }}
                    showValidationMessage={NumberOfunitValidation}
                    validationMessage={"حقل اجباري"}
                />
                <InputAHSF
                    fieldsName="UnitPrice"
                    show={true}
                    comma={true}
                    defaultValue={props.ViewData ? BudgetItemsRequestedFromSoman?.
                        unitPrice
                        : ""}
                    disabled={props.shouldDisableFields}

                    onChange={(e) => {
                        setUnitPrice(e.target.value);
                    }}
                    showValidationMessage={UnitPriceValidation}
                    validationMessage={"حقل اجباري"}
                />
                <InputAHSF
                    fieldsName="Total"
                    value={UnitPrice * NumberOfunit}
                    show={true}
                    disabled={true}

                    onChange={(e) => {
                        setTotal(e.target.value);
                    }}
                    showValidationMessage={false}
                    validationMessage={"حقل اجباري"}
                />
            </div>

        </div>










        {
            props.shouldDisableFields ?
                <>

                </> : <>

                    <div className="ConainerButtonAHSF">
                        <ButtonAHSF
                            onClick={props.Action == "edit" ? EditItemsRequestedFromSomanAdd : AddItemsRequestedFromSomanAdd
                            }
                            text={"حفظ"}
                            show={true}
                        />
                    </div>
                </>
        }




    </>
    return (
        <>
            {
                props.Action == "edit" ? BudgetItemsRequestedFromSoman ? HTML : <></> : HTML

            }
        </>
    )
}
export default BudgetItemsRequestedFromSomanAdd